import {
  DESELECT_JOB_INDUSTRY_FILTER,
  DESELECT_JOB_TYPE_FILTER,
  FETCH_JOBS,
  FETCH_NEXT_JOBS,
  FETCH_RECENT_JOBS,
  FETCH_SIMILAR_FEATURED_JOBS,
  FETCH_SIMILAR_SPONSORED_JOBS,
  FETCH_SPONSORED_JOBS,
  RESET_JOB_FILTERS,
  RESET_SEARCH,
  SELECT_FLOAT_BUTTON,
  SELECT_JOB_INDUSTRY_FILTER,
  SELECT_JOB_TYPE_FILTER,
  SELECT_RADIUS_FILTER,
  SET_HR_MODE,
  SET_KEYWORD_SEARCH_FILTER,
  SET_SALARY_FILTER,
  SET_SHOW_RECENT_JOBS,
} from "./jobsConstants";
import { getDocs } from "firebase/firestore";
import {
  asyncActionError,
  asyncActionFinish,
  asyncActionStart,
} from "../../app/async/asyncReducer";
import {
  dataFromSnapshot,
  INITIAL_SEARCH,
  LIMIT,
  logErrorInFirestore,
} from "../../app/firestore/firestoreService";

export function fetchJobs(jobs) {
  return {
    type: FETCH_JOBS,
    payload: jobs,
  };
}

export function fetchNextJobs({
  query,
  queryCode,
  searchDirection = INITIAL_SEARCH,
}) {
  return async function (dispatch) {
    dispatch(asyncActionStart());
    try {
      const snapshot = await getDocs(query);
      const firstVisible = snapshot.docs[0];
      const lastVisible = snapshot.docs[snapshot.docs.length - 1];
      const isMoreJobs = snapshot.docs.length >= LIMIT;
      const jobs = snapshot.docs.map((doc) => dataFromSnapshot(doc));
      dispatch({
        type: FETCH_NEXT_JOBS,
        payload: {
          jobs,
          isMoreJobs,
          firstVisible,
          lastVisible,
          queryCode,
          searchDirection,
        },
      });
    } catch (error) {
      dispatch(asyncActionError(error.message));
      await logErrorInFirestore({
        error: error.message,
        firestoreListener: true,
        notes: {
          query: query.toString(),
          queryCode: queryCode,
          errorFull: error.toString(),
        },
      });
    } finally {
      dispatch(asyncActionFinish());
    }
  };
}

export function listenToSponsoredJobs(jobs) {
  return {
    type: FETCH_SPONSORED_JOBS,
    payload: jobs,
  };
}

export function listenToRecentJobs(jobs) {
  return {
    type: FETCH_RECENT_JOBS,
    payload: jobs,
  };
}

export function fetchSimilarFeaturedJobs(jobs) {
  return {
    type: FETCH_SIMILAR_FEATURED_JOBS,
    payload: jobs,
  };
}

export function fetchSimilarSponsoredJobs(jobs) {
  return {
    type: FETCH_SIMILAR_SPONSORED_JOBS,
    payload: jobs,
  };
}

export function selectJobTypeFilter(filter) {
  return {
    type: SELECT_JOB_TYPE_FILTER,
    payload: filter,
  };
}

export function deselectJobTypeFilter() {
  return {
    type: DESELECT_JOB_TYPE_FILTER,
  };
}

export function selectJobIndustryFilter(filter) {
  return {
    type: SELECT_JOB_INDUSTRY_FILTER,
    payload: filter,
  };
}

export function deselectJobIndustryFilter() {
  return {
    type: DESELECT_JOB_INDUSTRY_FILTER,
  };
}

export function selectRadiusFilter(radius) {
  return {
    type: SELECT_RADIUS_FILTER,
    payload: radius,
  };
}

export function setKeywordSearchFilter(keyword) {
  return {
    type: SET_KEYWORD_SEARCH_FILTER,
    payload: keyword,
  };
}

export function setSalaryFilter(salary) {
  return {
    type: SET_SALARY_FILTER,
    payload: salary,
  };
}

export function selectFloatButton(button) {
  return {
    type: SELECT_FLOAT_BUTTON,
    payload: button,
  };
}

export function setShowRecentJobs(flag) {
  return {
    type: SET_SHOW_RECENT_JOBS,
    payload: flag,
  };
}

export function resetJobFilters() {
  return {
    type: RESET_JOB_FILTERS,
  };
}

export function resetSearch() {
  return {
    type: RESET_SEARCH,
  };
}

export function setHrMode(mode) {
  return {
    type: SET_HR_MODE,
    payload: mode,
  };
}
